package com.schoolconnect.app.feature.rolepicker

data class RolePickerOption(
    val id: String,
    val roleCode: String,
    val schoolId: String = "",
    val schoolCode: String = "",
    val roleLabel: String,
    val schoolLabel: String,
    val isLastUsed: Boolean = false
)

data class RolePickerUiState(
    val isVisible: Boolean = false,
    val title: String = "Choose Your Role",
    val subtitle: String = "Select how you'd like to continue",
    val options: List<RolePickerOption> = emptyList(),
    val selectedOptionId: String = "",
    val rememberSelection: Boolean = true,
    val canDismiss: Boolean = true,
    val isLoading: Boolean = false,
    val errorMessage: String = "",
    val isSubmitting: Boolean = false
)

sealed interface RolePickerUiEvent {
    data object CloseClicked : RolePickerUiEvent
    data object ContinueClicked : RolePickerUiEvent
    data class OptionSelected(val optionId: String) : RolePickerUiEvent
    data class RememberSelectionChanged(val value: Boolean) : RolePickerUiEvent
}
